<template>
  <div>
    <div>
      <span class="selected_lable">日期选择：</span>
      <el-date-picker
        v-model="durationStart"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      -
      <el-date-picker
        v-model="durationEnd"
        align="right"
        type="date"
        placeholder="选择日期"
        @change="durationChange"
        :clearable="isClear">
      </el-date-picker>
      &nbsp;
      &nbsp;
      选择医院：
      <el-select v-model="hospital" placeholder="请选择医院" @change="selectHospital">
        <el-option
          v-for="item in hospitalList"
          :key="item.hospitalId"
          :label="item.hospitalName"
          :value="item.hospitalId">
        </el-option>
      </el-select>
      &nbsp;
      &nbsp;
      年龄选择：
      <el-input class="input" v-model="startAge" placeholder="请输入最小年龄" @change="ageChange"></el-input>
      -
      <el-input class="input" v-model="endAge" placeholder="请输入最大年龄" @change="ageChange"></el-input>
      岁
    </div>
    <div>
      <div id="main" style="height: 640px">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import Global from "../Global";

export default {
  name: "PlaqueCountOne",
  data () {
    return {
      myChart: null,
      data: [],
      isClear: false,
      durationStart: new Date(1640966400000),
      durationEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      hospitalList: [],
      hospital: '',
      startAge: 0,
      endAge: 100
    }
  },
  mounted() {
    this.getHospitalList()
  },
  methods: {
    // 改变年龄
    ageChange () {
      this.getData()
    },
    // 选择医院
    selectHospital () {
      this.getData()
    },
    // 获取医院列表
    getHospitalList() {
      let that = this
      this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-hospital/hospital/getAllHospital'
      }).then(resp => {
        let data = resp.data
        if (data.code === 1000) {
          that.hospitalList = data.data
          that.hospital = that.hospitalList[3].hospitalId
          that.getData()
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 选择时间段
    durationChange () {
      this.getData()
    },
    // 获取数据
    getData () {
      // 情况数据数组
      this.data = []
      let durationStart = this.durationStart.getTime()
      let durationEnd = this.durationEnd.getTime() + 1000 * 60 * 60 * 24
      if (durationStart > durationEnd) {
        this.$message.error('结束时间不能小于开始时间')
        return
      }
      let that = this
      this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-order/order/countOrderLevelAll?durationStart=' + durationStart + '&durationEnd=' +
          durationEnd + '&hospitalId=' + that.hospital + '&startAge=' + that.startAge + '&endAge=' + that.endAge + '&sex=-1'
      }).then(resp => {
        let normal = {value: resp.data.data.normal, name: '正常' + resp.data.data.normal + '人（' + Number(resp.data.data.normal / resp.data.data.total * 100).toFixed(2) + '%）'}
        let qc1 = {value: resp.data.data.qc1, name: '质控一级' + resp.data.data.qc1 + '人（' + Number(resp.data.data.qc1 / resp.data.data.total * 100).toFixed(2) + '%）'}
        let qc2 = {value: resp.data.data.qc2, name: '质控二级' + resp.data.data.qc2 + '人（' + Number(resp.data.data.qc2 / resp.data.data.total * 100).toFixed(2) + '%）'}
        let qc3 = {value: resp.data.data.qc3, name: '质控三级' + resp.data.data.qc3 + '人（' + Number(resp.data.data.qc3 / resp.data.data.total * 100).toFixed(2) + '%）'}
        that.data.push(normal)
        that.data.push(qc1)
        that.data.push(qc2)
        that.data.push(qc3)
        that.initChart()
      })
    },
    // 初始化图表
    initChart () {
      // 如果存在实例需要进行销毁
      if (this.myChart != null) {
        this.myChart.dispose()
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById('main'))

      // 指定图表的配置项和数据
      let option = {
        series: [
          {
            type: 'pie',
            stillShowZeroSum: false,
            data: this.data,
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        ]
      }

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.input {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/plaque_count/PlaqueCountOne.vue